export const CONTAINER_TYPE = {
  CRATE: 1,
  CANISTER: 2,
};

export const CONTAINER_STATUS = {
  ON_A_TRIP: 1,
  HUB_STATION: 2,
};
